module.exports = __webpack_public_path__ + "img/star_card.a7755f79.png";